/** Preserve values containing equals signs and refuse malformed or duplicate rows before redirecting. */
export function authorizeParamsFromText(text: string): Record<string, string> {
    const entries: [string, string][] = []
    const names = new Set<string>()
    for (const line of text
        .split('\n')
        .map(item => item.trim())
        .filter(Boolean)) {
        const at = line.indexOf('=')
        const name = line.slice(0, at).trim()
        const value = line.slice(at + 1).trim()
        if (at < 1 || !name || !value || names.has(name)) throw new Error('oauth_authorize_params_invalid')
        names.add(name)
        entries.push([name, value])
    }
    return Object.fromEntries(entries)
}
